// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"375":"repo","414":"image","529":"package","543":"data","746":"catalogue","878":"generic"}[chunkId] + "." + {"375":"f7fcb196","414":"89115930","529":"94f72227","543":"d43b9cc5","746":"a5bc465b","878":"a64db6cf"}[chunkId] + ".js";
};